import React from 'react';
import NavLite from '../components/NavLite';
import Navbar from '../components/Navbar'
import Footer from '../components/Footer';
import Testimony from '../components/Testimony';
import ConfirmationImage from '../assets/PartyStarted.jpg'; // Replace with your hero image

function ReviewConfirmation() {
  return (

    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F4F3E1 ]">
    <title>Thank You for Requesting Your Visibility Review | Her Growth Co.</title>
<meta
name="description"
content="We received your request! Stay tuned for a detailed website visibility review tailored to your goals as a women entrepreneur."
/>
<meta
name="keywords"
content="thank you for your brand review, review submission complete, we received your audit request, next steps to grow online, expert insights incoming, brand audit confirmed, visibility support confirmation, on your way to expert authority"
/>
    <div className="bg-[#2E2D2B] min-h-screen flex flex-col">
      {/* Hero Banner */}
      <div
        className="relative h-auto bg-cover bg-center"
        style={{
          clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
          backgroundImage: `url(${ConfirmationImage})`,
          padding: "20px",
          width: "100%",
        }}
      >
     <NavLite/>
        <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
          <div className="flex items-center justify-center">
            <h1 className="text-white italic text-3xl max-w-40 font-semibold text-center">
              Confirmed!
            </h1>
          </div>
        </div>
      </div>

      <main className="flex-grow flex items-center justify-center py-12 md:py-24">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
          <div className="text-center">
            <svg
              className="mx-auto h-12 w-12 text-[#CFF098]"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
            <h2 className="mt-4 text-black text-2xl font-bold md:text-3xl md:leading-snug">
              Your Email is <span className='italic text-black bg-[#CFF098]'>Confirmed</span>!
            </h2>
            <p className="mt-2 text-black">
              Thank you for confirming your email address.
            </p>
            <div className="mt-6">
              <p className="text-black mb-2">
                **What Happens Next?**
              </p>
              <p className="text-black mb-4">
                Keep an eye on your inbox! Within the next few minutes, you'll receive a new email from us. This email will contain a short and simple form where you can provide us with some key information about your business and your website.
              </p>
              <p className="text-black mb-4">
                Once you submit this form, our team will get to work on your personalized website visibility review. This includes analyzing your website's speed, SEO, and overall user experience.
              </p>
              <p className="text-black">
                You can expect to receive your personalized Loom video review and a written summary within 5 Days.
              </p>
            </div>
            <a href='/services'>
              <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black mt-4">View Our Services</button>
              </a>
          </div>
        </div>
        
      </main>

      <Testimony/>
      <Footer />
    </div>
    </main>
  );
}

export default ReviewConfirmation;